export default {"src":"/_next/static/media/edge.aa5c8718.gif","height":666,"width":684,"blurWidth":0,"blurHeight":0};